"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CatasEnLaHaya() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="catas-en-la-haya" className="bg-background section">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-0 rounded-md overflow-hidden">
          {}
          <div ref={leftRef} className={`relative h-[400px] lg:h-auto min-h-[500px] transition-all duration-700 ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/centro_espanol_tasting.png" alt="Degustación de aceite en el Centro Español de La Haya" className="w-full h-full object-cover" />
          </div>

          {}
          <div ref={rightRef} className={`relative bg-accent p-8 lg:p-12 xl:p-16 flex flex-col justify-center transition-all duration-700 delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="absolute top-8 right-8 opacity-20 pointer-events-none">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/olive_branch_sketch.png" alt="" className="w-24 h-24 object-contain" />
            </div>

            <h2 className="font-serif text-[2.5rem] leading-[1.3] text-foreground mb-6">
              Degustación en La Haya
            </h2>

            <div className="space-y-4 mb-8 text-foreground font-sans">
              <p className="text-lg leading-[1.8]">
                Descubre la esencia del aceite de oliva virgen extra a través de una experiencia sensorial única en el Centro Español de La Haya.
              </p>
              <p className="leading-[1.8]">
                En nuestras catas, te invitamos a conocer los matices, aromas y sabores que hacen especial a nuestro aceite. Aprenderás a apreciar la calidad, la frescura y el carácter que solo un aceite familiar y artesanal puede ofrecer.
              </p>
              <p className="leading-[1.8]">
                Es más que una degustación: es un viaje desde el olivar hasta tu mesa, compartiendo la pasión y tradición de nuestra familia.
              </p>
            </div>

            <div>
              <Button asChild size="lg" className="btn">
                <Link to="#contacto">Ver Próximas Fechas</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}